import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { definitionListTerm } from './definitionListTerm.vanilla.mjs';

const TooltipDefinitionListTerm = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(definitionListTerm, classNameFromProps);
  return /* @__PURE__ */ jsx(
    "dt",
    {
      "data-scope": "tooltip",
      "data-part": "definition-list-term",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});
TooltipDefinitionListTerm.displayName = "Tooltip.DefinitionListTerm";

export { TooltipDefinitionListTerm };
//# sourceMappingURL=DefinitionListTerm.mjs.map
